import script from "./LimitMessages.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitMessages.vue?vue&type=script&setup=true&lang=js"

import "./LimitMessages.vue?vue&type=style&index=0&id=af0f89e0&lang=scss"

const __exports__ = script;

export default __exports__